import DATA_MODEL_TABLE from "./utils/constants/dataModelTable";
import { AdminPanelSettingsOutlined } from "@mui/icons-material";
import MyBookingsIcon from "./icons/MyBookingsIcon";
import BookEquipmentIcon from "./icons/BookEquipmentIcon";
import GroupViewsIcon from "./icons/GroupViewsIcon";
import AllBookingsIcon from './icons/AllBookingsIcon';
import { emptyExperiment } from "@digitallab/grid-common-frontend-components";
// Synchronous cache getter only. That module keeps the AppSync client behind its async loader so
// importing it here does not pull aws-appsync into every test that reaches constants.js.
import {
  getEquipmentGridColumns,
  getGridConstants
} from "./features/schema/helpers/equipmentGridColumns";

export const BOOKING_ADMIN = "BookingAdmin";
export const BOOKING_USER = "BookingUsers";
export const INSTRUMENT_REPOSITORY_ADMIN = "InstrumentRepositoryAdmin";
export const INSTRUMENT_REPOSITORY_USER = "InstrumentRepositoryUser";
export const INSTRUMENT_REPOSITORY_VIEWER = "InstrumentRepositoryViewer";
export const LOGBOOK_WRITER = "LogbookWriter";
export const LOGBOOK_ADMIN = "LogbookAdmin";
export const DEFAULT_IMAGE = "DefaultInstrument.png";
export const BACKDROP_ZINDEX = 99999;

export const MAX_BOOKINGS_COUNT = 500;

export const DEFAULT_LIMIT = 5;

export const GROUPS_TOKEN_PATH =
  "signInUserSession.accessToken.payload.cognito:groups";
export const ACCESS_TOKEN_PATH = "signInUserSession.idToken.payload";
export const SYNC_PROFILE_FIELDS = {
  givenName: "custom:firstName",
  familyName: "custom:lastName",
  name: "preferred_username",
  phone: "custom:phoneNumber",
  site: "custom:site",
};

export const FORCE_TIMELINE_RANGE_KEY = "booking:forceTimelineRange";
export const GROUP_VIEW_PREFILL_STORAGE_KEY = "booking:groupViewPrefill";

export const CALENDAR_DAY_VIEW_START_HOUR = 8;
export const CALENDAR_DAY_VIEW_END_HOUR = 19;
export const CALENDAR_DAY_VIEW_AM_PM = true;
export const CALENDAR_MORNING_START_HOUR = 8;
export const CALENDAR_MORNING_END_HOUR = 12;
export const CALENDAR_AFTERNOON_START_HOUR = 12;
export const CALENDAR_AFTERNOON_END_HOUR = 19;
export const CALENDAR_WEEK_INSTRUMENTS_COUNT_IN_DAY_SEGMENT = 7;

export const CLOUD_RESOURCE_ICONS = `/public/resources/deviceIcons/`;
export const DEFAULT_SITE = "Rotkreuz";

export const FIND_INSTRUMENTS_MAX_RANGE_IN_MONTHS = 6;

export const CALENDAR_WIDGET = "calendarWidget";

export const EquipmentSearchMeta = [
  {
    title: DATA_MODEL_TABLE.equipmentNickName.value,
    prop: DATA_MODEL_TABLE.equipmentNickName.key,
    dataTestId: "equipment-nick-name",
  },
  {
    title: DATA_MODEL_TABLE.equipmentId.value,
    prop: DATA_MODEL_TABLE.equipmentId.key,
    dataTestId: "equipment-id",
  },
  {
    title: DATA_MODEL_TABLE.serialNumber.value,
    prop: DATA_MODEL_TABLE.serialNumber.key,
    dataTestId: "serial-number",
  },
];

export const DEBOUNCE_DELAY = 1000;
export const DEFAULT_RECORDS_FETCHED = 900;
export const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const EDIT_BOOKING_URL = "editBookingUrl";
export const APPROVE_BOOKING_URL = "approveBookingUrl";
export const REJECT_BOOKING_URL = "rejectBookingUrl";
export const REVIEW_BOOKING_URL = "reviewBookingUrl";
export const INVALID_BARCODE_MESSAGE =
  "Invalid Code. Try a new one or try again";
export const NO_EQUIPMENT_FOR_FILTER = "No equipment for the filter";
export const INVALID_FILTER = "Selected filter is invalid";
export const CAMERA_TIMEOUT_MESSAGE = "Camera timed out. Please try again";
export const DEFAULT_SEARCH_FILTER = "Serial number";
export const SEARCH_DROP_DOWN_FILTERS_LIST = [
  {
    title: DATA_MODEL_TABLE.equipmentId.value,
    coloumn: "equipmentId",
    checked: true,
  },
  {
    title: DATA_MODEL_TABLE.equipmentModel.value,
    coloumn: "equipmentModel",
    checked: true,
  },
  {
    title: DATA_MODEL_TABLE.equipmentNickName.value,
    coloumn: "equipmentNickName",
    checked: true,
  },
  {
    title: DATA_MODEL_TABLE.serialNumber.value,
    coloumn: "serialNumber",
    checked: true,
  },
];

export const DEFAULT_DESCRIPTION_CONSTANT = {
  moduleVersion: "MODULE VERSION",
  moduleName: "APP NAME",
  ciJobId: "CI ID JOB",
  commitHash: "COMMIT HASH",
  updatedAt: "UPDATED AT",
};

export const ADD_INFO = [
  "bookableForUsers",
  "bookedBy",
  "bookedByEmail",
  DATA_MODEL_TABLE.instrumentAvailability.key,
  DATA_MODEL_TABLE.instrumentStatus.key,
];

export const GRID_VIEW = "GRID";
export const LIST_VIEW = "LIST";
export const TIMELINE_VIEW = "TIMELINE_VIEW";
export const LIST_GROUP_BY_BOOKING = "BOOKING";
export const LIST_GROUP_BY_NONE = "NONE";
export const LIST_GROUP_BY_EQUIPMENT = "EQUIPMENT";

export const LOCALHOST = "localhost";

export const POPOVER_DETAILS_EMPTY = {
  equipmentNickName: {
    key: "Nickname",
  },
  manufacturer: {
    key: "Manufacturer",
  },
  modelName: {
    key: "Model",
  },
  variant: {
    key: "Variant",
  },
  serialNumber: {
    key: "Serial number",
  },
  materialNumber: {
    key: "Material number",
  },
  equipmentId: {
    key: "Equipment ID",
  },
  responsiblePerson: {
    key: DATA_MODEL_TABLE.responsiblePerson.value,
  },
  systemStatus: {
    key: DATA_MODEL_TABLE.systemStatus.value,
  },
  configurationBaseline: {
    key: "Configuration",
  },
  softwareVersion: {
    key: "Software version",
  },
  belongingToGroup: {
    key: "Group",
  },
};

export const POPOVER_PROJECTDETAILS_EMPTY = {
  project: {
    key: "Project ID",
  },
  description: {
    key: "Description",
  },
};

export const POPOVER_WIDGET_PROJECTDETAILS_EMPTY = {
  project: {
    key: "Project ID",
  },
  description: {
    key: "Description",
  },
};

export const POPOVER_WIDGET_DETAILS_EMPTY = {
  equipmentNickName: {
    key: "Nickname",
  },
  modelName: {
    key: "Model",
  },
  responsiblePerson: {
    key: DATA_MODEL_TABLE.responsiblePerson.value,
  },
  systemStatus: {
    key: DATA_MODEL_TABLE.systemStatus.value,
  },
  configurationBaseline: {
    key: "Configuration",
  },
  softwareVersion: {
    key: "Software version",
  },
  belongingToGroup: {
    key: "Group",
  },
};

export const POPOVER_CLUSTER_DETAILS_EMPTY = {
  siteName: {
    key: "Site",
  },
  location: {
    key: "Location",
  },
  equipmentCategory: {
    key: "Category",
  },
  equipmentModel: {
    key: "Model",
  },
  variant: {
    key: "Variant",
  },
  equipmentNickName: {
    key: "Nickname",
  },
  responsiblePerson: {
    key: DATA_MODEL_TABLE.responsiblePerson.value,
  },
  qualificationStatus: {
    key: "Qualification status",
  },
  softwareVersion: {
    key: "Software version",
  },
  systemStatus: {
    key: DATA_MODEL_TABLE.systemStatus.value,
  },
};

export const entryType = {
  cluster: "CLUSTER",
  standaloneEquipment: "STANDALONE-EQUIPMENT",
  clusterSubequipment: "CLUSTER-SUBEQUIPMENT",
};
export const DEFAULT_CLUSTER_POPOVER_SKELETON = () => {
  return {
    equipmentDetail: {
      id: "",
      status: "",
      headerHeading: "",
      headerDetails: null,
      projectHeading: "",
      projectDetails: null,
      clusterSubEquipmentsHeading: "",
      clusterSubEquipments: [],
      detailHeading: "",
      detail: null,
      emailHREF: "",
      options: {
        hideFooter: false,
        hideHeader: false,
        hideBookingDetails: false,
      },
    },
  };
};

export const CLUSTER_SUB_EQUIPMENT_OBJ = {
  index: "",
  equipmentModel: "Model",
  variant: "Variant",
  equipmentNickName: "Nickname",
  qualificationStatus: "Qualification status",
  softwareVersion: "Software version",
};

export const MEGA_CLUSTER_SUB_EQUIPMENT_OBJ = {
  index: "",
  entryType: "",
  equipmentModel: "Model",
  variant: "Variant",
  equipmentNickName: "Nickname",
  qualificationStatus: "Qualification status",
  softwareVersion: "Software version",
};

export const POPOVER_CONTROL = ["index", "entryType"];

export const GXPemptyInstrumentsOptions = {
  qualificationStatus: [
    { key: "NA", value: "NA" },
    { key: "NOT_QUALIFIED", value: "Not qualified" },
    { key: "QUALIFIED", value: "Qualified" },
  ],
};

export const instrumentAvailabilityOptions = {
  instrumentAvailability: [
    { label: "Run", value: "Run" },
    { label: "Booking", value: "Booking" },
    { label: "Available", value: "Available" },
    { label: "Reservation", value: "Reservation" },
    { label: "Maintenance", value: "Maintenance" },
    { label: "Install", value: "Install" },
    { label: "Service", value: "Service" },
    { label: "Decommission", value: "Decommission" },
    { label: "Relocation", value: "Relocation" },
    { label: "Other", value: "Other" },
  ],
};

export const equipmentStatus = {
  active: { key: "ACTIVE", value: "Active" },
  pending: { key: "PENDING", value: "Pending" },
  deleted: { key: "DELETED", value: "Deleted" },
};
export const equipmentStatusOptions = [
  equipmentStatus?.active?.value,
  equipmentStatus?.deleted?.value,
  equipmentStatus?.pending?.value,
];

export const statusChip = {
  ACTIVE: equipmentStatus?.active?.value,
  PENDING: equipmentStatus?.pending?.value,
  DELETED: equipmentStatus?.deleted?.value,
};

export const CalibrationStatusOptions = {
  controlledEquipmentStatus: [
    { key: "NA", value: "NA" },
    { key: "NOT_CALIBRATED", value: "Not calibrated" },
    { key: "CALIBRATED", value: "Calibrated" },
  ],
};

export const HOUR_PREFERENCE = [
  {
    key: "MORNING",
    value: "Morning",
  },
  {
    key: "AFTERNOON",
    value: "Afternoon",
  },
  {
    key: "FULLDAY",
    value: "Full day",
  },
];

export const GXP_DROP_CHECK = [DATA_MODEL_TABLE.qualificationStatus.key];

export const HOME_SUB_MENU = [
  {
    icon: <BookEquipmentIcon />,
    text: "Book equipment",
    url: "/",
    isActive: true,
    disable: false,
  },
  {
    icon: <MyBookingsIcon />,
    text: "My bookings",
    url: "/bookings",
    isActive: false,
    disable: false,
  },
  {
    icon: <AllBookingsIcon />,
    text: "All bookings",
    url: "/bookings-all",
    isActive: true,
    disable: false,
  },
  {
    icon: <GroupViewsIcon />,
    text: "Group views",
    url: "/group-views",
    isActive: true,
    disable: false,
  },
  {
    icon: <AdminPanelSettingsOutlined />,
    text: "Admin panel",
    url: "/admin",
    isActive: false,
    disable: false,
  },
];

export const emptyBookingDetails = {
  bookingType: "Run",
  bookingFor: [],
  project: "",
  description: "",
  richDescription: "",
  elnId: emptyExperiment,
};

export const WHOM_TAB_LABEL = {
  BOOKED_TYPE: "Booking type",
  BOOKING_FOR: "Booking for",
  INFORMATION_FROM: "Information from",
  PROJECT: "Project",
  PROJECTS: "Projects",
  DESCRIPTION: "Description",
  ELN_ID: "eLN ID",
};

export const DURATION = 5000;
export const EQUIPMENT_BASED_DEFAULT_SHOW_COLUMNS = [
  {
    key: DATA_MODEL_TABLE.bookingAccessControl.key,
    val: DATA_MODEL_TABLE.bookingAccessControl.value,
    order: 0,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.isHazardous.key,
    val: DATA_MODEL_TABLE.isHazardous.value,
    order: 1,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.serialNumber.key,
    val: DATA_MODEL_TABLE.serialNumber.value,
    order: 2,
    show: true,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.equipmentId.key,
    val: DATA_MODEL_TABLE.equipmentId.value,
    order: 3,
    show: true,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.equipmentNickName.key,
    val: DATA_MODEL_TABLE.equipmentNickName.value,
    order: 4,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.location.key,
    val: DATA_MODEL_TABLE.location.value,
    order: 5,
    show: true,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.instrumentAvailability.key,
    val: DATA_MODEL_TABLE.instrumentAvailability.value,
    order: 6,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.systemStatus.key,
    val: DATA_MODEL_TABLE.systemStatus.value,
    order: 8,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.status.key,
    val: DATA_MODEL_TABLE.status.value,
    order: 9,
    show: true,
    sortStatus: false,
  },
];

export const DEFAULT_COLUMNS_LEGACY = {
  displayName: "",
  displayDefinition: {
    showColumns: [
      {
        key: DATA_MODEL_TABLE.checklists.key,
        val: DATA_MODEL_TABLE.checklists.value,
        order: 0,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.bookingAccessControl.key,
        val: DATA_MODEL_TABLE.bookingAccessControl.value,
        order: 0,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.shouldAssisted.key,
        val: DATA_MODEL_TABLE.shouldAssisted.value,
        order: 1,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.isHazardous.key,
        val: DATA_MODEL_TABLE.isHazardous.value,
        order: 1,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.serialNumber.key,
        val: DATA_MODEL_TABLE.serialNumber.value,
        order: 2,
        show: true,
        sortStatus: true,
      },
      {
        key: DATA_MODEL_TABLE.equipmentId.key,
        val: DATA_MODEL_TABLE.equipmentId.value,
        order: 3,
        show: true,
        sortStatus: true,
      },
      {
        key: DATA_MODEL_TABLE.equipmentNickName.key,
        val: DATA_MODEL_TABLE.equipmentNickName.value,
        order: 4,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.location.key,
        val: DATA_MODEL_TABLE.location.value,
        order: 5,
        show: true,
        sortStatus: true,
      },
      {
        key: DATA_MODEL_TABLE.instrumentAvailability.key,
        val: DATA_MODEL_TABLE.instrumentAvailability.value,
        order: 6,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.displayQualificationStatus.key,
        val: DATA_MODEL_TABLE.displayQualificationStatus.value,
        order: 7,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.systemStatus.key,
        val: DATA_MODEL_TABLE.systemStatus.value,
        order: 8,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.status.key,
        val: DATA_MODEL_TABLE.status.value,
        order: 9,
        show: true,
        sortStatus: false,
      },
    ],
    hideColumns: [
      {
        key: DATA_MODEL_TABLE.responsiblePerson.key,
        val: DATA_MODEL_TABLE.responsiblePerson.value,
        order: 9,
        show: false,
        sortStatus: true,
      },
      {
        key: DATA_MODEL_TABLE.manufacturer.key,
        val: DATA_MODEL_TABLE.manufacturer.value,
        order: 10,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.instrumentRUDI.key,
        val: DATA_MODEL_TABLE.instrumentRUDI.value,
        order: 11,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.equipmentCategory.key,
        val: DATA_MODEL_TABLE.equipmentCategory.value,
        order: 12,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.comment.key,
        val: DATA_MODEL_TABLE.comment.value,
        order: 13,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.belongingToGroup.key,
        val: DATA_MODEL_TABLE.belongingToGroup.value,
        order: 14,
        show: false,
        sortStatus: true,
      },
      {
        key: DATA_MODEL_TABLE.room.key,
        val: DATA_MODEL_TABLE.room.value,
        order: 15,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.systemOwner.key,
        val: DATA_MODEL_TABLE.systemOwner.value,
        order: 16,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.responsibleProxy.key,
        val: DATA_MODEL_TABLE.responsibleProxy.value,
        order: 17,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.sop.key,
        val: DATA_MODEL_TABLE.sop.value,
        order: 18,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.gxpRelevant.key,
        val: DATA_MODEL_TABLE.gxpRelevant.value,
        order: 24,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.instrumentGTIN.key,
        val: DATA_MODEL_TABLE.instrumentGTIN.value,
        order: 25,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.dateOfNextMaintanance.key,
        val: DATA_MODEL_TABLE.dateOfNextMaintanance.value,
        order: 26,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.softwareVersion.key,
        val: "Version",
        order: 27,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.configurationBaseline.key,
        val: DATA_MODEL_TABLE.configurationBaseline.value,
        order: 28,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.installedTests.key,
        val: DATA_MODEL_TABLE.installedTests.value,
        order: 29,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.qualificationDocuments.key,
        val: DATA_MODEL_TABLE.qualificationDocuments.value,
        order: 30,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.isVisualized.key,
        val: DATA_MODEL_TABLE.isVisualized.value,
        order: 31,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.dateOfLastMaintanance.key,
        val: DATA_MODEL_TABLE.dateOfLastMaintanance.value,
        order: 32,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.buildingLocation.key,
        val: DATA_MODEL_TABLE.buildingLocation.value,
        order: 33,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.floor.key,
        val: DATA_MODEL_TABLE.floor.value,
        order: 34,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.cluster.key,
        val: DATA_MODEL_TABLE.cluster.value,
        order: 35,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.equipmentModel.key,
        val: DATA_MODEL_TABLE.equipmentModel.value,
        order: 37,
        show: false,
        sortStatus: true,
      },
      {
        key: DATA_MODEL_TABLE.functionalLocation.key,
        val: DATA_MODEL_TABLE.functionalLocation.value,
        order: 38,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.costCenter.key,
        val: DATA_MODEL_TABLE.costCenter.value,
        order: 39,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.inventoryNumber.key,
        val: DATA_MODEL_TABLE.inventoryNumber.value,
        order: 40,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.variant.key,
        val: DATA_MODEL_TABLE.variant.value,
        order: 41,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.controlledEquipmentStatus.key,
        val: DATA_MODEL_TABLE.controlledEquipmentStatus.value,
        order: 43,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.weightInkg.key,
        val: DATA_MODEL_TABLE.weightInkg.value,
        order: 45,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.heightInmm.key,
        val: DATA_MODEL_TABLE.heightInmm.value,
        order: 46,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.lengthInmm.key,
        val: DATA_MODEL_TABLE.lengthInmm.value,
        order: 47,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.depthInmm.key,
        val: DATA_MODEL_TABLE.depthInmm.value,
        order: 48,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.clearanceLeftInmm.key,
        val: DATA_MODEL_TABLE.clearanceLeftInmm.value,
        order: 49,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.clearanceRightInmm.key,
        val: DATA_MODEL_TABLE.clearanceRightInmm.value,
        order: 50,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.clearanceHeightInmm.key,
        val: DATA_MODEL_TABLE.clearanceHeightInmm.value,
        order: 51,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.clearanceToFrontInmm.key,
        val: DATA_MODEL_TABLE.clearanceToFrontInmm.value,
        order: 52,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.clearanceBackwardsInmm.key,
        val: DATA_MODEL_TABLE.clearanceBackwardsInmm.value,
        order: 53,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.tags.key,
        val: DATA_MODEL_TABLE.tags.value,
        order: 54,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.linkedInstance.key,
        val: DATA_MODEL_TABLE.linkedInstance.value,
        order: 55,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.materialNumber.key,
        val: DATA_MODEL_TABLE.materialNumber.value,
        order: 56,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.network.key,
        val: DATA_MODEL_TABLE.network.value,
        order: 57,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.siteName.key,
        val: DATA_MODEL_TABLE.siteName.value,
        order: 58,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.qualificationStatus.key,
        val: DATA_MODEL_TABLE.qualificationStatus.value,
        order: 59,
        show: true,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.isBookable.key,
        val: DATA_MODEL_TABLE.isBookable.value,
        order: 60,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.instrumentStatus.key,
        val: DATA_MODEL_TABLE.instrumentStatus.value,
        order: 61,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.checkInRequired.key,
        val: DATA_MODEL_TABLE.checkInRequired.value,
        order: 62,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.checkInStartPeriod.key,
        val: DATA_MODEL_TABLE.checkInStartPeriod.value,
        order: 63,
        show: false,
        sortStatus: false,
      },
      {
        key: DATA_MODEL_TABLE.checkInGracePeriod.key,
        val: DATA_MODEL_TABLE.checkInGracePeriod.value,
        order: 64,
        show: false,
        sortStatus: false,
      },
    ],
  },
};
/**
 * Live, despite the name and the single entry: it shapes `DEFAULT_FILTER`, not the table.
 *
 * `defaultFilterObject` below iterates the keys of `DATA_MODEL_TABLE` and skips anything named here.
 * `trackPositionInCluster` is a real key, so the guard does match, and removing this array would add
 * a key to `DEFAULT_FILTER.filterDefinition` — which is compared by serialised equality the same way
 * the column layout is (see `listOfFieldsSortable`). Not dead code.
 */
export const listOfFieldsIgnoredInTable = [
  DATA_MODEL_TABLE.trackPositionInCluster?.key,
];
export const defaultFilterObject = () => {
  let obj = {};
  Object.keys(DATA_MODEL_TABLE)?.forEach((dataModel) => {
    if (!listOfFieldsIgnoredInTable.includes(dataModel)) {
      if (dataModel === DATA_MODEL_TABLE.belongingToGroup?.key) {
        obj["group"] = null;
      }
      if (dataModel === DATA_MODEL_TABLE.siteName?.key) {
        obj["site"] = null;
      }
      if (dataModel === DATA_MODEL_TABLE.equipmentCategory?.key) {
        obj["category"] = null;
      }
      obj[dataModel] = null;
    }
  });

  return obj;
};
export const DEFAULT_FILTER = {
  filterName: "",
  filterDefinition: {
    ...defaultFilterObject(),
    dateFrom: null,
    dateTo: null,
    inventoryIds: null,
  },
};
export const DEFAULT_PAGE_SIZE = 50;
export const MY_LAB = "My lab";
export const ALL_EQUIPMENT = "__ALL_EQUIPMENT__";
export const YES = "Yes";
export const DEFAULT_MYLAB_FILTER = {
  filterName: MY_LAB,
  filterDefinition: {
    ...defaultFilterObject(),
    dateFrom: null,
    dateTo: null,
    inventoryIds: null,
  },
};
export const BOOKING_CONFIG = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_GRAPHQL_ENDPOINT,
};

export const LP_CONFIG = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_LP_AWS_GRAPHQL_ENDPOINT,
};
export const REPO_CONFIG = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_REPO_AWS_GRAPHQL_ENDPOINT,
};
export const allTableColumnLegacy = (isEquipmentBased = false) => [
  {
    key: DATA_MODEL_TABLE.serialNumber.key,
    val: DATA_MODEL_TABLE.serialNumber.value,
    order: 1,
    show: true,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.checklists.key,
    val: DATA_MODEL_TABLE.checklists.value,
    order: 1,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.bookingAccessControl.key,
    val: DATA_MODEL_TABLE.bookingAccessControl.value,
    order: 2,
    show: !isEquipmentBased,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.isHazardous.key,
    val: DATA_MODEL_TABLE.isHazardous.value,
    order: 2,
    show: !isEquipmentBased,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.shouldAssisted.key,
    val: DATA_MODEL_TABLE.shouldAssisted.value,
    order: 2,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.equipmentId.key,
    val: DATA_MODEL_TABLE.equipmentId.value,
    order: 3,
    show: true,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.equipmentNickName.key,
    val: DATA_MODEL_TABLE.equipmentNickName.value,
    order: 4,
    show: true,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.location.key,
    val: DATA_MODEL_TABLE.location.value,
    order: 5,
    show: true,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.instrumentAvailability.key,
    val: DATA_MODEL_TABLE.instrumentAvailability.value,
    order: 6,
    show: !isEquipmentBased,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.displayQualificationStatus.key,
    val: DATA_MODEL_TABLE.displayQualificationStatus.value,
    order: 7,
    show: !isEquipmentBased,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.systemStatus.key,
    val: DATA_MODEL_TABLE.systemStatus.value,
    order: 8,
    show: !isEquipmentBased,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.status.key,
    val: DATA_MODEL_TABLE.status.value,
    order: 8,
    show: !isEquipmentBased,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.responsiblePerson.key,
    val: DATA_MODEL_TABLE.responsiblePerson.value,
    order: 9,
    show: false,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.manufacturer.key,
    val: DATA_MODEL_TABLE.manufacturer.value,
    order: 10,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.instrumentRUDI.key,
    val: DATA_MODEL_TABLE.instrumentRUDI.value,
    order: 11,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.equipmentCategory.key,
    val: DATA_MODEL_TABLE.equipmentCategory.value,
    order: 12,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.comment.key,
    val: DATA_MODEL_TABLE.comment.value,
    order: 13,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.belongingToGroup.key,
    val: DATA_MODEL_TABLE.belongingToGroup.value,
    order: 14,
    show: false,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.room.key,
    val: DATA_MODEL_TABLE.room.value,
    order: 15,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.systemOwner.key,
    val: DATA_MODEL_TABLE.systemOwner.value,
    order: 16,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.responsibleProxy.key,
    val: DATA_MODEL_TABLE.responsibleProxy.value,
    order: 17,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.sop.key,
    val: DATA_MODEL_TABLE.sop.value,
    order: 18,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.gxpRelevant.key,
    val: DATA_MODEL_TABLE.gxpRelevant.value,
    order: 24,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.instrumentGTIN.key,
    val: DATA_MODEL_TABLE.instrumentGTIN.value,
    order: 25,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.dateOfNextMaintanance.key,
    val: DATA_MODEL_TABLE.dateOfNextMaintanance.value,
    order: 26,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.softwareVersion.key,
    val: "Version",
    order: 27,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.configurationBaseline.key,
    val: DATA_MODEL_TABLE.configurationBaseline.value,
    order: 28,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.installedTests.key,
    val: DATA_MODEL_TABLE.installedTests.value,
    order: 29,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.qualificationDocuments.key,
    val: DATA_MODEL_TABLE.qualificationDocuments.value,
    order: 30,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.isVisualized.key,
    val: DATA_MODEL_TABLE.isVisualized.value,
    order: 31,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.dateOfLastMaintanance.key,
    val: DATA_MODEL_TABLE.dateOfLastMaintanance.value,
    order: 32,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.buildingLocation.key,
    val: DATA_MODEL_TABLE.buildingLocation.value,
    order: 33,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.floor.key,
    val: DATA_MODEL_TABLE.floor.value,
    order: 34,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.cluster.key,
    val: DATA_MODEL_TABLE.cluster.value,
    order: 35,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.equipmentModel.key,
    val: DATA_MODEL_TABLE.equipmentModel.value,
    order: 37,
    show: isEquipmentBased,
    sortStatus: true,
  },
  {
    key: DATA_MODEL_TABLE.functionalLocation.key,
    val: DATA_MODEL_TABLE.functionalLocation.value,
    order: 38,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.costCenter.key,
    val: DATA_MODEL_TABLE.costCenter.value,
    order: 39,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.inventoryNumber.key,
    val: DATA_MODEL_TABLE.inventoryNumber.value,
    order: 40,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.variant.key,
    val: DATA_MODEL_TABLE.variant.value,
    order: 41,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.controlledEquipmentStatus.key,
    val: DATA_MODEL_TABLE.controlledEquipmentStatus.value,
    order: 43,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.weightInkg.key,
    val: DATA_MODEL_TABLE.weightInkg.value,
    order: 45,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.heightInmm.key,
    val: DATA_MODEL_TABLE.heightInmm.value,
    order: 46,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.lengthInmm.key,
    val: DATA_MODEL_TABLE.lengthInmm.value,
    order: 47,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.depthInmm.key,
    val: DATA_MODEL_TABLE.depthInmm.value,
    order: 48,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.clearanceLeftInmm.key,
    val: DATA_MODEL_TABLE.clearanceLeftInmm.value,
    order: 49,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.clearanceRightInmm.key,
    val: DATA_MODEL_TABLE.clearanceRightInmm.value,
    order: 50,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.clearanceHeightInmm.key,
    val: DATA_MODEL_TABLE.clearanceHeightInmm.value,
    order: 51,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.clearanceToFrontInmm.key,
    val: DATA_MODEL_TABLE.clearanceToFrontInmm.value,
    order: 52,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.clearanceBackwardsInmm.key,
    val: DATA_MODEL_TABLE.clearanceBackwardsInmm.value,
    order: 53,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.tags.key,
    val: DATA_MODEL_TABLE.tags.value,
    order: 54,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.linkedInstance.key,
    val: DATA_MODEL_TABLE.linkedInstance.value,
    order: 55,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.materialNumber.key,
    val: DATA_MODEL_TABLE.materialNumber.value,
    order: 56,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.network.key,
    val: DATA_MODEL_TABLE.network.value,
    order: 57,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.siteName.key,
    val: DATA_MODEL_TABLE.siteName.value,
    order: 58,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.qualificationStatus.key,
    val: DATA_MODEL_TABLE.qualificationStatus.value,
    order: 59,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.isBookable.key,
    val: DATA_MODEL_TABLE.isBookable.value,
    order: 60,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.instrumentStatus.key,
    val: DATA_MODEL_TABLE.instrumentStatus.value,
    order: 61,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.checkInRequired.key,
    val: DATA_MODEL_TABLE.checkInRequired.value,
    order: 62,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.checkInStartPeriod.key,
    val: DATA_MODEL_TABLE.checkInStartPeriod.value,
    order: 63,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.checkInGracePeriod.key,
    val: DATA_MODEL_TABLE.checkInGracePeriod.value,
    order: 64,
    show: false,
    sortStatus: false,
  },
  {
    key: DATA_MODEL_TABLE.labArea.key,
    val: DATA_MODEL_TABLE.labArea.value,
    order: 65,
    show: false,
    sortStatus: false,
  },
];

export const listOfBooleanRequiredLegacy = [
  DATA_MODEL_TABLE.isBookable?.key,
  DATA_MODEL_TABLE.isVisualized?.key,
  DATA_MODEL_TABLE.checkInRequired?.key,
  DATA_MODEL_TABLE.isHazardous?.key,
  DATA_MODEL_TABLE.shouldAssisted?.key,
];

export const listOfIntBooleanRequired = [
  DATA_MODEL_TABLE.isHazardous?.key,
  DATA_MODEL_TABLE.shouldAssisted?.key,
];

export const listOfCheckBoxFiltersLegacy = [
  DATA_MODEL_TABLE.belongingToGroup.key,
  DATA_MODEL_TABLE.manufacturer.key,
  DATA_MODEL_TABLE.equipmentCategory.key,
  DATA_MODEL_TABLE.responsiblePerson.key,
  DATA_MODEL_TABLE.dateOfNextMaintanance.key,
  DATA_MODEL_TABLE.tags.key,
  DATA_MODEL_TABLE.linkedInstance.key,
  DATA_MODEL_TABLE.equipmentModel.key,
  DATA_MODEL_TABLE.variant.key,
  DATA_MODEL_TABLE.qualificationStatus.key,
  DATA_MODEL_TABLE.displayQualificationStatus.key,
  DATA_MODEL_TABLE.controlledEquipmentStatus.key,
  DATA_MODEL_TABLE.sop.key,
  DATA_MODEL_TABLE.gxpRelevant.key,
  DATA_MODEL_TABLE.systemStatus.key,
  DATA_MODEL_TABLE.status.key,
  DATA_MODEL_TABLE.labArea.key,
];
export const listOfDateRequiredLegacy = [
  DATA_MODEL_TABLE.dateOfLastMaintanance?.key,
  DATA_MODEL_TABLE.dateOfNextMaintanance?.key,
];
export const listOfFieldsIgnoredForSearchLegacy = [
  DATA_MODEL_TABLE.dateOfLastMaintanance?.key,
  DATA_MODEL_TABLE.dateOfNextMaintanance?.key,
  DATA_MODEL_TABLE.isHazardous?.key,
  DATA_MODEL_TABLE.shouldAssisted?.key,
  DATA_MODEL_TABLE.checklists?.key,
  DATA_MODEL_TABLE.checkInRequired?.key,
  DATA_MODEL_TABLE.checkInStartPeriod?.key,
  DATA_MODEL_TABLE.checkInGracePeriod?.key,
  DATA_MODEL_TABLE.isBookable?.key,
  DATA_MODEL_TABLE.isVisualized?.key,
  DATA_MODEL_TABLE.displayQualificationStatus?.key,
];
export const listOfFieldsNoFilterLegacy = [
  DATA_MODEL_TABLE.siteName?.key,
  DATA_MODEL_TABLE.instrumentAvailability?.key,
  DATA_MODEL_TABLE.checklists?.key,
];
/**
 * The only source that actually gates sorting.
 *
 * `getColumnObj` sets `sortable: !listOfFieldsNotSortable.includes(key)` — see
 * features/equipment-list/EquipmentHelper.js — so every column not named here is sortable, which is
 * 58 of the 61 in `allTableColumn`. That reaches all three equipment grids: EquipmentMainPage
 * directly, and both EquipmentBookingList variants because their column merge spreads the
 * `dataModel` entry last and so overrides the booking-side `sortable`.
 *
 * Note the disagreement with the two neighbours below. `allTableColumn` marks only 6 entries
 * `sortStatus: true`, and `listOfFieldsSortable` names 5 — neither matches the 58 that are sortable
 * in practice. That is accumulated drift, not intent: `sortStatus` never fed the grid.
 */
export const listOfFieldsNotSortableLegacy = [
  DATA_MODEL_TABLE.tags?.key,
  DATA_MODEL_TABLE.sop?.key,
  DATA_MODEL_TABLE.checklists?.key,
];

/**
 * Feeds the persisted `sortStatus` field and nothing else. Do not use it to decide sortability —
 * that is `listOfFieldsNotSortable` above.
 *
 * `sortStatus` looks dead: nothing reads it by name, in this app or in the grid component (all 140
 * occurrences in grid-common-frontend-components are its own literal defaults). It is not. It is
 * read *by value*, through serialised equality:
 *
 *   EquipmentMainPage.jsx  isSameConfig(a, b) => JSON.stringify(a) === JSON.stringify(b)
 *                          isSameConfig(normalizedLastDisplayColumns, DEFAULT_COLUMNS)
 *                          └─ drives `disableResetAll`
 *
 * So every byte of a persisted column entry matters, `sortStatus` included, and these four sites
 * must stay byte-identical or the Reset All button silently stops disabling itself:
 *
 *   1. allTableColumn                                  (this file)
 *   2. DEFAULT_COLUMNS                                 (this file)
 *   3. buildDisplayDefinitionFromColumns               features/equipment-list/EquipmentMainPage.jsx
 *   4. the same mapping in `useBooking`                components/EquipmentList/Service/commonsService.js
 *
 * Correcting `sortStatus` to match real sortability therefore means changing all four in lockstep —
 * and every already-saved layout would still hold the old values and compare unequal until the user
 * resets. Left alone deliberately; the drift is harmless precisely because nothing reads the field
 * for meaning.
 */
export const listOfFieldsSortable = [
  DATA_MODEL_TABLE.responsiblePerson?.key,
  DATA_MODEL_TABLE.location?.key,
  DATA_MODEL_TABLE.belongingToGroup?.key,
  DATA_MODEL_TABLE.serialNumber?.key,
  DATA_MODEL_TABLE.equipmentModel?.key,
];

export const listOfFilterBlankRequiredLegacy = [
  DATA_MODEL_TABLE.serialNumber?.key,
  DATA_MODEL_TABLE.materialNumber?.key,
  DATA_MODEL_TABLE.equipmentId?.key,
];
export const listOfNumberFilterLegacy = [
  DATA_MODEL_TABLE.weightInkg?.key,
  DATA_MODEL_TABLE.heightInmm?.key,
  DATA_MODEL_TABLE.lengthInmm?.key,
  DATA_MODEL_TABLE.depthInmm?.key,
  DATA_MODEL_TABLE.clearanceBackwardsInmm?.key,
  DATA_MODEL_TABLE.clearanceHeightInmm?.key,
  DATA_MODEL_TABLE.clearanceLeftInmm?.key,
  DATA_MODEL_TABLE.clearanceRightInmm?.key,
  DATA_MODEL_TABLE.clearanceToFrontInmm?.key,
  DATA_MODEL_TABLE.qualificationDocuments?.key,
  DATA_MODEL_TABLE.installedTests?.key,
  DATA_MODEL_TABLE.checkInGracePeriod?.key,
  DATA_MODEL_TABLE.checkInStartPeriod?.key,
];

/**
 * The per-column flag lists, derived from the schema.
 *
 * Each `…Legacy` array above is the hand-written list it replaced, kept as the fallback: until
 * `loadEquipmentGridColumns()` resolves, `getGridConstants()` answers null and the original list is
 * used, so a screen that renders before the schema loads behaves exactly as it did.
 *
 * These are **functions**, not arrays — a caller must invoke them. Most call sites are `.js`/`.jsx`
 * where the type checker cannot catch a missing `()`, and passing the function where an array is
 * expected fails quietly, so grep each name after touching it.
 *
 * Two lists are deliberately absent and stay hand-written:
 *   listOfFieldsSortable      feeds the persisted `sortStatus`, which is compared byte-for-byte
 *                             against DEFAULT_COLUMNS — see its own comment above.
 *   listOfIntBooleanRequired  chooses ["Yes","No"] over ["true","false"] for one filter; the schema
 *                             models the boolean render slot but not this presentational split.
 *   listOfFieldsIgnoredInTable  shapes DEFAULT_FILTER, not the grid.
 */
const gridConstant = (derivedKey, legacyValue) => () => getGridConstants()?.[derivedKey] ?? legacyValue;

/**
 * Columns whose visibility depends on which view is asking, which the schema cannot express — its
 * `show` comes from a single static `grid.defaultVisible` per field.
 *
 * `isEquipmentBased` means "the list is grouped by equipment", so the booking-specific columns are
 * suppressed and the equipment model is shown instead. Applied over the derived column data rather
 * than pushed into the shared schema, since booking is the only consumer that needs it.
 */
const VISIBILITY_BY_VIEW = {
  [DATA_MODEL_TABLE.bookingAccessControl?.key]: (isEquipmentBased) => !isEquipmentBased,
  [DATA_MODEL_TABLE.isHazardous?.key]: (isEquipmentBased) => !isEquipmentBased,
  [DATA_MODEL_TABLE.instrumentAvailability?.key]: (isEquipmentBased) => !isEquipmentBased,
  [DATA_MODEL_TABLE.displayQualificationStatus?.key]: (isEquipmentBased) => !isEquipmentBased,
  [DATA_MODEL_TABLE.systemStatus?.key]: (isEquipmentBased) => !isEquipmentBased,
  [DATA_MODEL_TABLE.status?.key]: (isEquipmentBased) => !isEquipmentBased,
  [DATA_MODEL_TABLE.equipmentModel?.key]: (isEquipmentBased) => isEquipmentBased
};

/**
 * The grid's column list, from the schema.
 *
 * Falls back to the hand-written list until `loadEquipmentGridColumns()` resolves. Adds the columns
 * the schema knows about that the hand-written list never had — they arrive hidden, so they appear
 * in the columns tool panel rather than in the grid.
 *
 * @param isEquipmentBased - True when the list is grouped by equipment; see VISIBILITY_BY_VIEW.
 * @returns One entry per column, in schema order.
 */
export const allTableColumn = (isEquipmentBased = false) => {
  const derived = getEquipmentGridColumns();
  if (!derived) {
    return allTableColumnLegacy(isEquipmentBased);
  }
  return derived.map((column) => {
    const perView = VISIBILITY_BY_VIEW[column.key];
    return perView ? { ...column, show: perView(isEquipmentBased) } : column;
  });
};

/**
 * The factory-default column layout, derived from the same list.
 *
 * Derived rather than hand-written so it cannot drift from what the persistence write sites emit —
 * `EquipmentMainPage` decides whether Reset All is enabled by serialising a saved layout and
 * comparing it byte-for-byte with this, so any disagreement silently leaves that button enabled.
 * Building both from one source makes them agree by construction.
 *
 * @param isEquipmentBased - Passed through to {@link allTableColumn}.
 * @returns The default layout in the persisted wire shape.
 */
export const DEFAULT_COLUMNS = (isEquipmentBased = false) => {
  const columns = allTableColumn(isEquipmentBased);
  const toStored = (column, index) => ({
    key: column.key,
    val: column.val,
    order: index,
    show: column.show,
    sortStatus: column.sortStatus
  });
  return {
    displayName: "",
    displayDefinition: {
      showColumns: columns.filter((column) => column.show).map(toStored),
      hideColumns: columns.filter((column) => !column.show).map(toStored)
    }
  };
};

export const listOfBooleanRequired = gridConstant("booleanRequired", listOfBooleanRequiredLegacy);
export const listOfCheckBoxFilters = gridConstant("checkBoxFilters", listOfCheckBoxFiltersLegacy);
export const listOfDateRequired = gridConstant("dateRequired", listOfDateRequiredLegacy);
export const listOfFieldsIgnoredForSearch = gridConstant(
  "fieldsIgnoredForSearch",
  listOfFieldsIgnoredForSearchLegacy
);
export const listOfFieldsNoFilter = gridConstant("fieldsNoFilter", listOfFieldsNoFilterLegacy);
export const listOfFieldsNotSortable = gridConstant(
  "fieldsNotSortable",
  listOfFieldsNotSortableLegacy
);
export const listOfFilterBlankRequired = gridConstant(
  "filterBlankRequired",
  listOfFilterBlankRequiredLegacy
);
export const listOfNumberFilter = gridConstant("numberFilter", listOfNumberFilterLegacy);

export const systemStatusOptions = ["In service", "Out of service"];
export const qualificationCalibrationStatus = {
  qualified: "Qualified",
  not_qualified: "Not qualified",
  calibrated: "Calibrated",
  not_calibrated: "Not calibrated",
  NA: "NA",
};

export const MAX_COUNT_CAPACITY = 50;
export const equipmentTabGroup = [
  {
    id: 1,
    heading: "What equipment?",
    content: "",
    isDisable: false,
  },
  {
    id: 2,
    heading: "Date and Time?",
    content: "Define experiment range",
    isDisable: true,
  },
  {
    id: 3,
    heading: "For what/whom?",
    content: "",
    isDisable: true,
  },
];
export const IconStatus = [
  {
    icon: "confirm",
    text: "Available",
    backgroundColor: "#D7E0F7",
    color: "#0B41CD",
  },
  {
    //left for compatibility with old types
    icon: "schedule_on",
    text: "Booking",
    backgroundColor: "var(--one-color-cobas-accent-purple-200)",
    color: "var(--one-color-cobas-accent-purple-800)",
    textColor: "var(--one-color-accent-quaternary-4)",
  },
  {
    //left for compatibility with old types
    icon: "order_approval",
    text: "Reservation",
    backgroundColor: "var(--one-color-cyan-100)",
    color: "var(--one-color-accent-cyan-800)",
    textColor: "var(--one-color-cyan-900)",
  },
  {
    icon: "circle_play",
    text: "Run",
    backgroundColor: "var(--one-color-cobas-accent-purple-200)",
    color: "var(--one-color-cobas-accent-purple-800)",
    textColor: "var(--one-color-accent-quaternary-4)",
  },
  {
    icon: "user_group",
    text: "Assisted Run",
    backgroundColor: "var(--one-color-cobas-accent-purple-200)",
    color: "var(--one-color-cobas-accent-purple-800)",
    textColor: "var(--one-color-accent-quaternary-4)",
  },
  {
    icon: "",
    text: "First time user",
    backgroundColor: "var(--Light-Background-positive-2, #E4F5F1)",
    color: "var(--Light-Accent-quaternary-4, #7D0096)",
    textColor: "var(--one-color-accent-quaternary-4)",
    firstTimeUserBadge: {
      backgroundColor: "var(--Dark-Accent-secondary-2, #ED4A0D)",
      textColor: "#FBFBFA",
    },
  },
  {
    icon: "support_technical",
    text: "Maintenance",
    backgroundColor: "var(--one-color-cobas-yellow-200)",
    color: "var(--one-color-brown-700)",
  },
  {
    icon: "install",
    text: "Install",
    backgroundColor: "var(--one-color-cobas-yellow-200)",
    color: "var(--one-color-brown-700)",
  },
  {
    icon: "administration",
    text: "Service",
    backgroundColor: "var(--one-color-cobas-yellow-200)",
    color: "var(--one-color-brown-700)",
  },
  {
    icon: "install_off",
    text: "Decommission",
    backgroundColor: "var(--one-color-cobas-yellow-200)",
    color: "var(--one-color-brown-700)",
  },
  {
    icon: "locator",
    text: "Relocation",
    backgroundColor: "var(--one-color-cobas-yellow-200)",
    color: "var(--one-color-brown-700)",
  },
  {
    icon: "test_result",
    text: "Other",
    backgroundColor: "var(--one-color-cobas-yellow-200)",
    color: "var(--one-color-brown-700)",
  },
  {
    icon: "circle_info",
    text: "Information",
    backgroundColor: "#E6F4EA",
    color: "#1E8E3E",
    textColor: "#1E8E3E",
  },
];

export const INFORMATION_BOOKING_TYPE = "Information";
export const INFORMATION_BOOKING_COLOR = "#E6F4EA";
export const INFORMATION_BOOKING_FCOLOR = "#1E8E3E";
export const INFORMATION_BOOKING_DESCRIPTION_MAX = 200;

export const agGridAutoGroupfieldName = "ag-Grid-AutoColumn";

export const BOOKING_TYPE = {
  BOOKED: "Booking",
  RESERVED: "Reservation",
  MAINTENANCE: "Maintenance",
  AVAILABLE: "Available",
};

export const TIMELINE_TYPE = {
  DAY: "day",
  "3DAY": "3day",
  WEEK: "week",
  MONTH: "month",
};

export const singleEventSkeleton = {
  active: false,
  allDay: false,
  bookingId: null,
  color: "#D7E0F7",
  start: null,
  end: null,
  fcolor: "#0B41CD",
  id: null,
  resource: null,
  type: BOOKING_TYPE.AVAILABLE,
  overlap: false,
  title: "Available",
};

export const BookingMeta = {
  fields: {
    detailExpander: {
      text: "",
      width: 40,
      minWidth: 40,
    },
    dateFrom: {
      text: "Experiment start date",
      width: 220,
      minWidth: 220,
    },
    dateTo: {
      text: "Experiment end date",
      width: 200,
      minWidth: 200,
    },
    type: {
      text: "Booking type",
      width: 200,
      minWidth: 200,
    },
    hazardous: {
      text: "Approval status",
      width: 200,
      minWidth: 200,
    },
    equipment: {
      text: "Equipment",
      width: 200,
      minWidth: 200,
    },
    reservedForUsers: {
      text: "Booking for",
      width: 200,
      minWidth: 200,
    },
    createdBy: {
      text: "Created by",
      width: 200,
      minWidth: 200,
      siteRestricted: true,
    },
    createdAt: {
      text: "Created on",
      width: 200,
      minWidth: 200,
      siteRestricted: true,
    },
    project: {
      text: "Project",
      width: 200,
      minWidth: 200,
    },
    description: {
      text: "Description",
      width: 200,
      minWidth: 200,
    },
    richDescription: {
      text: "Description",
      width: 260,
      minWidth: 260,
    },
    elnId: {
      text: "eLN ID",
      width: 200,
      minWidth: 200,
    },
    assistent: {
      text: "Assistant",
      width: 200,
      minWidth: 200,
    },
    assistentReason: {
      text: "Assistant Reason",
      width: 250,
      minWidth: 250,
    },
    checkIn: {
      text: "Check-in",
      width: 200,
      minWidth: 200,
      sortable: false,
    },
    actionButton: {
      text: "",
      width: 80,
    },
  },
};

export const BookingMetaByEquipment = {
  fields: {
    dateFrom: {
      text: "Start time",
      width: 280,
      minWidth: 280,
      maxWidth: 320,
      lockVisible: true,
      suppressMovable: true,
    },
    dateTo: {
      text: "End time",
      width: 280,
      minWidth: 280,
      maxWidth: 320,
      lockVisible: true,
      suppressMovable: true,
    },
    type: {
      text: "Booking type",
      width: 200,
      minWidth: 200,
      lockVisible: true,
      suppressMovable: true,
    },
    hazardous: {
      text: "Approval status",
      width: 200,
      minWidth: 200,
      lockVisible: true,
      suppressMovable: true,
    },
    bookingFor: {
      text: "Booking for",
      width: 200,
      minWidth: 200,
      lockVisible: true,
      suppressMovable: true,
    },
    createdBy: {
      text: "Created by",
      width: 200,
      minWidth: 200,
      siteRestricted: true,
    },
    createdAt: {
      text: "Created on",
      width: 200,
      minWidth: 200,
      siteRestricted: true,
    },
    project: {
      text: "Project",
      width: 200,
      minWidth: 200,
      lockVisible: true,
      suppressMovable: true,
    },
    description: {
      text: "Description",
      width: 200,
      minWidth: 200,
      lockVisible: true,
      suppressMovable: true,
    },
    richDescription: {
      text: "Description",
      width: 260,
      minWidth: 260,
      lockVisible: true,
      suppressMovable: true,
    },
    equipmentId: {
      text: "Equipment ID",
      width: 200,
      minWidth: 200,
    },
    equipmentNickName: {
      text: "Nickname",
      width: 200,
      minWidth: 200,
    },
    equipmentModel: {
      text: "Model",
      width: 200,
      minWidth: 200,
    },
    serialNumber: {
      text: "Serial Number",
      width: 200,
      minWidth: 200,
    },
    location: {
      text: "Location",
      width: 200,
      minWidth: 200,
    },
    actionButton: {
      text: "",
      width: 80,
      // minWidth: 80,
    },
  },
};

export const MyBookingMeta = BookingMeta;

export const DropBookingMeta = {
  fields: {
    detailExpander: {
      text: "",
      width: 40,
      minWidth: 40,
    },
    dateFrom: {
      text: "Experiment start date",
      width: 220,
      minWidth: 220,
    },
    dateTo: {
      text: "Experiment end date",
      width: 200,
      minWidth: 200,
    },
    type: {
      text: "Booking type",
      width: 200,
      minWidth: 200,
    },
    hazardous: {
      text: "Approval status",
      width: 200,
      minWidth: 200,
    },
    equipment: {
      text: "Equipment",
      width: 200,
      minWidth: 200,
    },
    assistent: {
      text: "Assistant",
      width: 200,
      minWidth: 200,
    },
    assistentReason: {
      text: "Assistant Reason",
      width: 250,
      minWidth: 250,
    },
    reservedForUsers: {
      text: "Booking for",
      width: 200,
      minWidth: 200,
    },
    remark: {
      text: "Reason",
      width: 200,
      minWidth: 200,
    },
    active: {
      text: "Booking status",
      width: 200,
      minWidth: 200,
    },
    actionButton: {
      text: "",
      width: 200,
      minWidth: 200,
    },
  },
};
export const CLUSTER_DETAILS_ATTRIBUTE_META = {
  siteName: {
    key: "siteName",
    value: "Site",
  },
  location: {
    key: "location",
    value: "Location",
  },
  equipmentCategory: {
    key: "equipmentCategory",
    value: "Category",
  },
  equipmentModel: {
    key: "modelName",
    value: "Model",
  },
  variant: {
    key: "variant",
    value: "Variant",
  },
  equipmentNickName: {
    key: "equipmentNickName",
    value: "Nickname",
  },
  responsiblePerson: {
    key: "responsiblePerson",
    value: DATA_MODEL_TABLE.responsiblePerson.value,
  },
  softwareVersion: {
    key: "softwareVersion",
    value: "Software version",
  },
  qualificationStatus: {
    key: "qualificationStatus",
    value: "Qualification status",
  },
  systemStatus: {
    key: "systemStatus",
    value: DATA_MODEL_TABLE.systemStatus.value,
  },
  checklists: {
    key: "checklists",
    value: "Documentation",
  },
};

/**
 * Attributes shown in the equipment popover, in display order.
 *
 * Key order is display order, and this declaration is the order non-V&V equipment renders in — it is
 * unchanged from before V&V Status was added, since every key this card introduced is filtered out
 * for those records. `visibleAttributeKeys` owns both rules: `vnvStatus` and `configurationDetails`
 * render only on V&V equipment, `equipmentNickName` / `manufacturer` only on everything else, and
 * the V&V view additionally hoists `vnvStatus` and `serialNumber` to the front.

 */
export const STANDALONE_ATTRIBUTE_META = {
  equipmentNickName: {
    key: "equipmentNickName",
    value: "Nickname",
  },
  manufacturer: {
    key: "manufacturer",
    value: "Manufacturer",
  },
  vnvStatus: {
    key: "vnvStatus",
    value: DATA_MODEL_TABLE.vnvStatus.value,
  },
  equipmentModel: {
    key: "modelName",
    value: "Model",
  },
  variant: {
    key: "variant",
    value: "Variant",
  },
  serialNumber: {
    key: "serialNumber",
    value: "Serial number",
  },
  materialNumber: {
    key: "materialNumber",
    value: "Material number",
  },
  equipmentId: {
    key: "equipmentId",
    value: "Equipment ID",
  },
  responsiblePerson: {
    key: "responsiblePerson",
    value: DATA_MODEL_TABLE.responsiblePerson.value,
  },
  configurationBaseline: {
    key: "configurationBaseline",
    value: "Configuration",
  },
  configurationDetails: {
    key: "configurationDetails",
    value: DATA_MODEL_TABLE.configurationDetails.value,
  },
  softwareVersion: {
    key: "softwareVersion",
    value: "Software version",
  },
  belongingToGroup: {
    key: "belongingToGroup",
    value: "Group",
  },
  location: {
    key: "location",
    value: "Location",
  },
  systemStatus: {
    key: "systemStatus",
    value: DATA_MODEL_TABLE.systemStatus.value,
  },
  checklists: {
    key: "checklists",
    value: "Documentation",
  },
};
export const SHOW_ADVANCE_FILTER_TOOLTIP = "Show search and filters options";
export const CHANGE_EXPIREMENT_TEXT = "Change experiment range";
export const DEFINE_EXPIREMENT_TEXT = "Define experiment range";
export const ENTRY_TYPE = {
  cluster: "CLUSTER",
  standaloneEquipment: "STANDALONE-EQUIPMENT",
  clusterSubequipment: "CLUSTER-SUBEQUIPMENT",
};

export const POSITION_IN_CLUSTER = "position_in_cluster";
export const CLUSTER_DETAILS_HEADING = "Cluster details";
export const EQUIPMENT_DETAILS_HEADING = "Equipment details";
export const ATTRIBUTES_HEADING = "Attributes";
export const EVENT = "EVENT";
export const RESOURCE = "RESOURCE";

export const PopOverTableMeta = {
  fields: {
    variant: {
      text: "Variant",
    },
    equipmentNickName: {
      text: "Nickname",
    },
    qualificationStatus: {
      text: "Qualification status",
    },
    softwareVersion: {
      text: "Software version",
    },
  },
};

export const TIMELINE_BUFFER_UNITS = {
  DAY: 30,
  "3DAY": 60,
  WEEK: 90,
  MONTH: 12,
};

export const TIMELINE_CONFIG = {
  DAY: {
    timeline: {
      type: TIMELINE_TYPE.DAY,
      resolutionHorizontal: "hour",
      timeCellStep: 60,
      timeLabelStep: 60,
      weekNumbers: false,
      currentTimeIndicator: true,
      eventHeight: "variable",
      size: TIMELINE_BUFFER_UNITS.DAY * 2 + 1, // -30 days + current + 30 days = 61 days total
    },
  },
  "3DAY": {
    timeline: {
      type: TIMELINE_TYPE.DAY,
      timeCellStep: 360, // 360 minutes = 6 hours per slot
      timeLabelStep: 360,
      weekNumbers: false,
      resolutionHorizontal: "hour",
      currentTimeIndicator: true,
      eventHeight: "variable",
      size: TIMELINE_BUFFER_UNITS["3DAY"] * 2 + 1, // -60 days + current + 60 days = 121 days total
    },
  },
  WEEK: {
    timeline: {
      // type: TIMELINE_TYPE.WEEK,
      type: TIMELINE_TYPE.DAY, // Use 'day' type to avoid automatic week boundaries
      startDay: 1,
      endDay: 0,
      timeCellStep: 1440, // 24 hours = 1 day
      timeLabelStep: 1440,
      columnWidth: 30,
      weekNumbers: false,
      resolutionHorizontal: "day",
      currentTimeIndicator: true,
      eventHeight: "variable",
      size: TIMELINE_BUFFER_UNITS.WEEK * 5 + 30, // 90 days * 5 + 30 = 480 days total (to allow users to see all max 52 weekly recurring bookings to be visible in timeline weekly view. Added 30 days for buffor)
    },
  },
  MONTH: {
    timeline: {
      type: TIMELINE_TYPE.MONTH,
      allDay: false,
      timeCellStep: 1440,
      timeLabelStep: 1440,
      resolutionHorizontal: "week",
      currentTimeIndicator: true,
      eventHeight: "variable",
      size: TIMELINE_BUFFER_UNITS.MONTH * 3 + 2, // -12 months * 3 + 2 = 38 months total (to allow users to see all max 3 yearly/all max 24 monthly recurring bookings to be visible in timeline monthly view. Added 2 months for buffor)
    },
  },
};

export const BOOKING_WRAPPER_INITALIZE = {
  isEditMode: false,
  isRedirectToAdmin: false,
  forceMyBookingsRedirect: false,
  keepLastUrlRedirect: false,
  isOngoing: false,
  editBookingData: null,
};

export const UPDATE_REQUEST = "UPDATE_REQUEST";
export const CANCEL_REQUEST = "CANCEL_REQUEST";
export const BOOKING_REQUEST = "BOOKING_REQUEST";

export const BOOKING_POP_UP_WRAPPER_INITALIZE = {
  title: "",
  content: "",
  open: false,
  onApprove: "",
};

export const GOOGLE_CALENDAR_API_URL = "https://www.googleapis.com/calendar/v3";

export const MyLabMenuArray = [
  {
    key: "remove",
    value: "Remove from My lab",
    availableFor: [entryType.standaloneEquipment, entryType.cluster],
  },
  {
    key: "add",
    value: "Add to My lab",
    availableFor: [entryType.standaloneEquipment, entryType.cluster],
  },
];
export const NOTIFICATION_TYPES = {
  Orange: "Planned application maintenance",
  Violet: "Planned application update",
  Red: "Unforseen incident",
  Blue: "Information on the application",
  Green: "Positive information to the user",
};
export const BANNER_COLORS = {
  Blue: {
    Heading: "var(--one-color-cobas-blue-600)",
    TextToDisplay: "var(--one-color-legacy-blue-200)",
    Icon: "circle_info",
    IconType: "outlined",
  },
  Green: {
    Heading: "var(--one-color-olive-900)",
    TextToDisplay: "var(--one-color-accent-olive-200)",
    Icon: "circle_confirm",
    IconType: "outlined",
  },
  Orange: {
    Heading: "var(--one-color-cobas-accent-orange-600)",
    TextToDisplay: "var(--one-color-orange-100)",
    Icon: "circle_warning",
    IconType: "outlined",
  },
  Red: {
    Heading: "var(--one-color-red-a-300)",
    TextToDisplay: "var(--one-color-cobas-red-200)",
    Icon: "circle_clear",
    IconType: "outlined",
  },
  Violet: {
    Heading: "var(--one-color-cobas-accent-purple-800)",
    TextToDisplay: "var(--one-color-cobas-accent-purple-200)",
    Icon: "repeat_warning",
    IconType: "outlined",
  },
};
export const PRED_SITE_NAME = "Basel pRED";
export const GRED_SITE_NAME = "S. San Francisco";
export const OPENSEARCH = "OPENSEARCH";

export const DEFAULT_NEW_USER_NOTIFICATION_THRESHOLDS = [
  {
    source: "http://booking.digitallab.roche.com",
    channel: "EMAIL",
    severityThreshold: "LOW",
  },
];
